export const SET_KODIRECTORY_DATA = 'SET_KODIRECTORY_DATA';
export const SET_SINGLE_KODIRECTORY_DATA = 'SET_SINGLE_KODIRECTORY_DATA';
export const ADD_KODIRECTORY_DATA = 'ADD_KODIRECTORY_DATA';
export const DELETE_KODIRECTORY_DATA = 'DELETE_KODIRECTORY_DATA';



// WEBPACK FOOTER //
// ./src/store/modules/kodirectory/action-types.js